<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
        {{'DELETE_RECORD_CONFIRMATION' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="dialogContent">
    <div>{{'DELETE_LOCAL_TEMPLATE_CONFIRMATION' | translate}}</div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialogActionsBtns">
    <button class="openCloseBtn" mat-raised-button (click)="onYesClick()" color="primary">{{'YES' | translate}}</button>
    <button class="openCloseBtn" mat-raised-button [mat-dialog-close] color="warn">{{'NO' | translate}}</button>
</mat-dialog-actions>